// extracted by mini-css-extract-plugin
module.exports = {"inline":"pending-count-badge_inline__G9OIl"};